{
  "notifications": {
    "waitlistedUpgradeEcoTo": {
      "ECOPREMIUM": {
        "moreThan48HoursToDeparture": {
          "text": "You are waitlisted for a Premium Economy upgrade on your {origin}–{destination} flight. We will email you about the status no later than 48 hours before departure."
        }
      },
      "BUSINESS": {
        "moreThan48HoursToDeparture": {
          "text": "You are waitlisted for a Business Class upgrade on your {origin}-{destination} flight. We will email you about the status no later than 48 hours before departure."
        }
      }
    }
  }
}
